import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export interface useSearchResult {
  searchTerm: string | undefined
  setSearchTerm: (searchTerm: string) => void
}

const useSearch = (initialSearchTerm = ''): useSearchResult => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const [searchTerm, setCurrentSearch] = useState(
    searchParams.has('search') ? searchParams.get('search') ?? undefined : initialSearchTerm,
  )

  useEffect(() => {
    // Update URL with the current page
    const updatedSearchParams = new URLSearchParams(window.location.search)

    // Clear the search term if it's null or an empty string
    if ((searchTerm ?? '') === '') {
      updatedSearchParams.delete('search')
    } else {
      updatedSearchParams.set('search', searchTerm ?? '')
    }

    // Replace the current state in the history without adding a new entry
    window.history.replaceState(null, '', `${window.location.pathname}?${updatedSearchParams.toString()}`)
  }, [searchTerm])

  const setSearchTerm = (searchTerm: string) => {
    setCurrentSearch(searchTerm)
  }

  return {
    searchTerm,
    setSearchTerm,
  }
}

export default useSearch
